import { logEvent } from '../helpers/analytics';
import { api } from './api';
import { cable } from './cable';

export function runSimulation({ scale, startEvent, finishedEvent, overrides }) {
  return dispatch => {
    api.post('/api/simulations', { scale, overrides }).then(response => {
      dispatch({ type: startEvent || 'SIMULATION_STARTED', payload: response.data });

      if (response.data.scores) {
        dispatch({ type: finishedEvent || 'SIMULATION_FINISHED', payload: response.data });
      } else {
        cable.subscriptions.create(
          {
            channel: 'SimulationsChannel',
            simulation_id: response.data.id,
          },
          {
            received: data => {
              console.log('[ActionCable] [Received]', data);
              dispatch({ type: finishedEvent || 'SIMULATION_FINISHED', payload: data });
            },
          }
        );
      }
    });
    // .catch(e => {
    //   console.log(e);
    // });
  };
}

export function checkForSimulations(s) {
  return (dispatch, getState) => {
    setTimeout(() => {
      const { simulations, user } = getState();
      if (!simulations.results || simulations.isRunning) {
        if (s == 30) {
          // refresh page
          window.location.reload(true);
        }
      }
    }, 1000 * s);
  };
}

export function getCurrentAfterTaxIncome() {
  return dispatch => {
    api.post('/api/simulations/initial_take_home_pay').then(response => {
      dispatch({ type: 'CURRENT_AFTER_TAX_INCOME_FETCHED', payload: response.data });
    });
  };
}

export const logSim = (prefix, overrides) => {
  logEvent('RunSimulation', {
    for: prefix == '' ? 'permanent' : 'testing',
    updating: prefix,
    overrides: overrides,
  });
};

export function runFullSimulation(prefix = '', overrides) {
  if (prefix == '' && overrides) {
    console.warn('Updating primary simulation state with overrides.');
  }
  logSim(prefix, overrides);
  return runSimulation({
    overrides,
    scale: 'full',
    finishedEvent: `${prefix}SIMULATION_FINISHED`,
    startEvent: `${prefix}SIMULATION_STARTED`,
  });
}

export function runQuickSimulation(prefix = '', overrides) {
  if (prefix == '' && overrides) {
    console.warn('Updating primary simulation state with overrides.');
  }
  logSim(prefix, overrides);
  return runSimulation({
    overrides,
    scale: 'full', //Run the same number as full to prevent bugs.
    finishedEvent: `${prefix}SIMULATION_FINISHED`,
    startEvent: `${prefix}SIMULATION_STARTED`,
  });
}

export function setPlanImpactUpdatedPath(path) {
  return { type: 'PLAN_IMPACT_UPDATED_PATH_SET', path };
}

export function makeSimulationPermanent(tempSimulation) {
  return { type: 'SIMULATION_MOVED_TO_PERMANENT', payload: tempSimulation };
}
